// frontend/src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Phone, Mail, MapPin } from 'lucide-react';
import IndustrialLogo from './IndustrialLogo';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            {/* Logo   */}
          <Link to="/" className="flex items-center space-x-3 space-x-reverse group">
            <IndustrialLogo variant="default" />
          </Link>
          <hr />
          <br />
            <p className="text-gray-400 mb-6 leading-relaxed">
               تکنو پلیمر اسپادانا ارایه کننده خدمات طراحی و ساخت انواع قالب های لاستیک و تولید کننده انواع قطعات لاستیکی با بیش از 7 سال سابقه فعال در زمینه صنعت. 
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4 space-x-reverse">
              {[
                { icon: Instagram, href: '#', color: 'hover:text-pink-400' },
                { icon: Facebook, href: '#', color: 'hover:text-blue-400' },
                { icon: Twitter, href: '#', color: 'hover:text-sky-400' },
                { icon: Youtube, href: '#', color: 'hover:text-red-400' },
              ].map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    className={`text-gray-400 ${social.color} transition-colors p-2 rounded-lg bg-gray-800 hover:bg-gray-700`}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-white text-lg mb-6">لینک‌های سریع</h3>
            <div className="flex flex-col space-y-3">
              {[
                { name: 'محصولات', href: '/products' },
                { name: 'گالری', href: '/gallery' },
                { name: 'مقالات', href: '/blog' },
                { name: 'خدمات', href: '/services' },
                { name: 'درباره ما', href: '/about' },
                { name: 'تماس با ما', href: '/contact' },
              ].map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-gray-400 hover:text-pink-400 transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-white text-lg mb-6">ارتباط با ما</h3>
            <div className="flex flex-col space-y-4">
              <div className="flex items-center space-x-3 space-x-reverse text-gray-400">
                <Phone size={18} />
                <span>031-91550821</span>
              </div>
              <div className="flex items-center space-x-3 space-x-reverse text-gray-400">
                <Phone size={18} />
                <span>09132102584</span>
              </div>
              <div className="flex items-center space-x-3 space-x-reverse text-gray-400">
                <Mail size={18} />
                <a href='mailto:info@techpolymer.ir'><span>info@techpolymer.ir</span></a>
              </div>
              <div className="flex items-start space-x-3 space-x-reverse text-gray-400">
                <MapPin size={18} className="mt-1" />
                <span>اصفهان، خیابان امام خمینی، خیابان بسیج</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © ۲۰۲۴ SPADANA Techno Polymer. تمام حقوق محفوظ است.
          </p>
          <div className="flex space-x-6 space-x-reverse mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
              
            </a>
            <a href="mailto:m.ghodrati1988@gmail.com" className="text-gray-400 hover:text-white text-sm transition-colors">
              Designed & Programmed by MOHSEN GHODRATI
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;